import { CanDeactivateFn } from '@angular/router';

/**
 * Interfaccia che un componente deve implementare per partecipare alla
 * deactivation guard. Il metodo `canDeactivate()` restituisce `true` se la
 * navigazione può procedere, `false` per bloccarla (es. modifiche non salvate).
 */
export interface CanComponentDeactivate {
  canDeactivate(): boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  return component.canDeactivate();
};
